import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { CadastroGrupo } from '../../../../../shared/interfaces/cadastro-grupo';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CadastroGrupoService } from 'app/shared/services/cadastro-grupo.service';

@Component({
  selector: 'app-cadastro-grupo-table-popup',
  templateUrl: 'cadastro-grupo-table-popup.component.html',
  styleUrls: ['cadastro-grupo-table-popup.component.scss']
})
export class CadastroGrupoTablePopupComponent implements OnInit {
  public itemForm: FormGroup;
  public itemDiretivasFatForm: FormGroup;

  grupos: CadastroGrupo[];
  grupo: CadastroGrupo;
  cep: any;
  isLoading = false;
  isLoadingGrupo = false;
  errorMsg: string;

  maskFone = {
    mask: '(00) {*}0000-0000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCep = {
    mask: '00000-000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCpf = {
    mask: '000.000.000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCnpj = {
    mask: '00.000.000/0000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };
  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };
  maskLower = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toLowerCase()
  };

  maskEmail = {
    mask: /^\S*@?\S*$/,
    prepare: (email: any) => email.toLowerCase()
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snack: MatSnackBar,
    private cadastroGrupoService: CadastroGrupoService,
    public dialogRef: MatDialogRef<CadastroGrupoTablePopupComponent>,
    private fb: FormBuilder,
    private confirmService: AppConfirmService
  ) { }

  ngOnInit() {
    this.buildItemForm(this.data.payload)
  }

  buildItemForm(item: CadastroGrupo) {
    this.itemForm = this.fb.group({
      id: [item.id],
      uuid: [item.uuid],
      descricao: [item.descricao, [Validators.required]],
      classificacao: [item.classificacao, [Validators.required]]
    })

  }

  submit() {
    console.log(this.itemForm.value.endereco);
    if (this.itemForm.invalid) {
      return;
    }
    this.cadastroGrupoService.saveOrUpdate(this.itemForm.value)
    .subscribe((grupo) => {
      this.grupo = this.itemForm.value;

      if (grupo) {
        this.snack.open('Grupo Salvo com sucesso!', 'OK', { duration: 5500 });
      }else{

      }
    },(err: HttpErrorResponse) => {
      this.snack.open('Erro ao salvar o Grupo!', 'ERRO', { duration: 5500 });
    });
  }

  close() {
    this.dialogRef.close(false);
  }
}
